import axios from 'axios'
import router from '../router'
import urls from '../assets/js/urls'
import store from '@S'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
let isTokenRefreshing = false
let subscribesArr = []
// api
let API = location.origin + '/_api'
if (process.env.NODE_ENV === 'development') {
  // API = 'http://localhost:6030'
  API = 'http://fc.daoquest.com/_api'
}

function subscribesArrRefresh (cb) {
  subscribesArr.push(cb)
}

function reloadSubscribesArr (newToken) {
  subscribesArr.map(cb => cb(newToken))
}

function isTokenExpire (serverTokenExpire) {
  return getUTCTime(new Date()) >= getUTCTime(new Date(serverTokenExpire))
}
// console.log(subscribesArrRefresh, reloadSubscribesArr, isTokenExpire)

// 获取UTC时间
function getUTCTime (now) {
  let year = now.getUTCFullYear()
  let month = now.getUTCMonth()
  let date = now.getUTCDate()
  let hours = now.getUTCHours()
  let minutes = now.getMinutes()
  let seconds = now.getUTCSeconds()
  let ms = now.getUTCMilliseconds()
  return Date.UTC(year, month, date, hours, minutes, seconds, ms)
}
axios.defaults.timeout = 180000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.baseURL = API
var bURL = API

// 下载http://localhost:3030//org/exp?... 处理失败.
if (bURL.substr(-1) === '/') {
  bURL = bURL.substring(0, bURL.length - 1)
}
store.commit('common/updateBase', {
  name: 'baseURL',
  value: bURL
})

axios.interceptors.request.use((config) => {
  config.headers.common.AppCode = window.sessionStorage.getItem(store.state.common.AppCode)
  config.headers.common.MenuCode = window.sessionStorage.getItem(store.state.common.MenuCode)
  let token = window.localStorage.getItem(store.state.common.keyToken)
  if (token) {
    config.headers.common.Authorization = store.state.common.tokenPre + token
  }
  let serverTokenExpire = window.localStorage.getItem(store.state.common.tokenExpire)
  if (config.url.includes(urls.login)) {
    return config
  }
  if (serverTokenExpire && isTokenExpire(serverTokenExpire) && !config.url.includes(urls.refreshToken)) {
    if (!isTokenRefreshing) {
      isTokenRefreshing = true
      axios.get(urls.refreshToken).then(({
        data: {
          token,
          expire
        }
      }) => {
        isTokenRefreshing = false
        // window.sessionStorage.setItem(store.state.common.keyToken, token)
        // window.sessionStorage.setItem(store.state.common.tokenExpire, expire)
        window.localStorage.setItem(store.state.common.keyToken, token)
        window.localStorage.setItem(store.state.common.tokenExpire, expire)
        reloadSubscribesArr(token)
      }).catch(() => {
        isTokenRefreshing = false
        subscribesArr = []
        // window.sessionStorage.clear()
        // window.localStorage.clear()
        // router.push('/login')
      })
    }
    let retry = new Promise((resolve, reject) => {
      subscribesArrRefresh((newToken) => {
        config.headers.Authorization = store.state.common.tokenPre + newToken
        resolve(config)
      })
    })
    return retry
  } else {
    return config
  }
}, (err) => {
  ViewUI.Message.error('错误的传参')
  return Promise.reject(err)
})

axios.interceptors.response.use((res) => {
  if (res.data == null) return Promise.resolve(res)
  let msg = res.data.message
  if (msg == null || msg === '') {
    return Promise.resolve(res)
  } else {
    ViewUI.Message.error(msg)
    return Promise.reject(res)
  }
}, (err) => {
  let status = 0
  let msg = ''
  if (err && err.response) {
    status = err.response.status
    msg = err.response.data.message
  }
  // 捕捉token过期时,跳转到登录页
  if (status === 401) {
    if (msg !== null || msg !== '') {
      msg = msg.toLocaleLowerCase().includes('expired') ? '登录过期，请重新登录。' : msg
      ViewUI.Message.error(msg)
    } else {
      console.log(status)
      console.log(msg)
      // Notify.create({
      //   message: '',
      //   color: 'negative',
      //   timeout: 5000,
      //   position: 'top'
      // })
    }
    // window.sessionStorage.clear()
    router.push('/login')
    return
  } else if (status === 500) {
    msg = '系统异常, 请联系管理员查看服务器日志'
  }
  if (msg === '') {
    msg = '网络异常'
  }
  console.log(status, msg)
  ViewUI.Message.error(msg)
  return Promise.reject(err)
})

export default {
  get (url) {
    return new Promise((resolve, reject) => {
      axios.get(url).then(
        response => resolve(response),
        error => reject(error)
      )
    })
  },
  post (url, params) {
    return new Promise((resolve, reject) => {
      axios.post(url, params).then(
        response => resolve(response),
        error => reject(error)
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/http/index.js